import React from "react";
import Slider from "react-slick";
import ReviewCard from "../../Components/ReviewCard";
import { mainLeaf } from "../../assets";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { client } from "../../client";

const Reviews = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 10000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    client.fetch('*[_type == "testimonials"]').then((data) => setReviews(data));
  }, []);

  return (
    <motion.div
      id="reviews"
      whileInView={{ y: [50, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      {/* <SectionTitle sub="Reviews" title="Our Clients Feedback" /> */}
      <img src={mainLeaf} alt="" className="mainLeaf" />

      <div className="mainContent">
        <Slider {...settings} className="slider">
          {reviews.map((review, i) => {
            return (
              <div key={i}>
                <ReviewCard review={review} />
              </div>
            );
          })}
        </Slider>
      </div>
    </motion.div>
  );
};

export default Reviews;
